module.exports = __webpack_public_path__ + "static/media/tradicional-1.f6cab537.png";